import { MUSIC24_PLANS, BillingInterval, Music24PlanId } from './music24StripePlans';

const KEY = 'music24CheckoutIntent';
let memoryIntent: CheckoutIntent | null = null;
export interface CheckoutIntent {
  plan: string;
  interval: BillingInterval;
}

/**
 * Old website and email links use the ids from before the rename. Keep them working. `pro` is not
 * here: since the 2026-10-08 pricing `pro` is the Pro plan (it was Label before the rename).
 */
const LEGACY_PLAN_IDS: Record<string, Music24PlanId> = { basic: 'artist', premium: 'manager' };

export function parseCheckoutIntent(search: string): CheckoutIntent | null {
  const params = new URLSearchParams(search);
  const priceId = params.get('checkoutPriceId');
  for (const plan of MUSIC24_PLANS) {
    for (const interval of ['monthly', 'yearly'] as const) {
      if (priceId !== null && priceId !== '' && plan.prices[interval].legacyPriceIds.includes(priceId)) {
        return { plan: plan.id, interval };
      }
    }
  }
  const rawPlan = params.get('plan');
  const plan = rawPlan !== null ? (LEGACY_PLAN_IDS[rawPlan] ?? rawPlan) : null;
  const interval = params.get('interval');
  return MUSIC24_PLANS.some((p) => p.id === plan) && (interval === 'monthly' || interval === 'yearly')
    ? { plan: plan as string, interval }
    : null;
}

export function captureCheckoutIntent(): void {
  const intent = parseCheckoutIntent(window.location.search);
  if (!intent) return;
  memoryIntent = intent;
  try {
    sessionStorage.setItem(KEY, new URLSearchParams({ ...intent }).toString());
  } catch {
    /* Storage can be unavailable in private browsers; keep the in-memory selection. */
  }
}

export function readCheckoutIntent(): CheckoutIntent | null {
  try {
    return parseCheckoutIntent(sessionStorage.getItem(KEY) ?? '') ?? memoryIntent;
  } catch {
    return memoryIntent;
  }
}

export function clearCheckoutIntent(): void {
  memoryIntent = null;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* An unavailable store must not block the successful checkout. */
  }
}
